<template>
  <svg
    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
    viewBox="-10 0 310 300"
  >
    <path
      fill="currentColor"
      d="M150 113q21 0 35.5 14.5t14.5 35t-14.5 35.5t-35.5 15t-35.5 -15t-14.5 -35.5t14.5 -35t35.5 -14.5zM150 131q-13 0 -22 9.5t-9 22.5t9 22t22 9t22 -9t9 -22t-9 -22.5t-22 -9.5zM150 69q28 0 53.5 12t43 33.5t24.5 48.5q1 4 -1 7.5t-5.5 4.5t-7 -1t-4.5 -6
q-9 -35 -37.5 -57.5t-65.5 -22.5t-65.5 22.5t-37.5 57.5q-1 4 -4.5 6t-7 1t-5.5 -4.5t-1 -7.5q7 -27 24.5 -48.5t43 -33.5t53.5 -12z"
    />
  </svg>
</template>